export default {
    state: {
        include:[]
    },
    mutations: {
        setInclude(state,include) {
            state.include = include;
        }
    },
    actions: {
        addKeepAlive({ commit, state }, includeItem) {
            var include = state.include;
            for(var index in include){
                if(include[index] == includeItem) {
                    return;
                }
            }
            include.push(includeItem);
            commit('setInclude', include);
        },deleteKeepAlive({ commit, state }, includeItem) {
            var include = state.include;
            for(var index in include){
                if(include[index] == includeItem) {
                    include.splice(index,1);
                    commit('setInclude', include);
                    break;
                }
            }
        },clearInclude({ commit, state }) {
            commit('setInclude', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/keeper.js